// Blocked Twitch terms sync issue dialog for the library

import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../../components/ui/alert-dialog';
import type { LibraryBlockedTermsSyncResult } from '../hooks';

type BlockedTermsSyncIssueDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRetry: () => Promise<LibraryBlockedTermsSyncResult>;
  onReconnect: () => void;
};

const BlockedTermsSyncIssueDialog: React.FC<
  BlockedTermsSyncIssueDialogProps
> = ({ open, onOpenChange, onRetry, onReconnect }) => {
  const [retryingSync, setRetryingSync] = React.useState(false);

  const handleRetry = async (event: React.MouseEvent) => {
    event.preventDefault();
    setRetryingSync(true);
    try {
      await onRetry();
    } finally {
      setRetryingSync(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Blocked terms unavailable</AlertDialogTitle>
          <AlertDialogDescription>
            We couldn&apos;t sync your Twitch blocked terms right now. This
            usually clears up on its own. Try again in a moment, or reconnect
            your Twitch account if it keeps failing.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel type="button" disabled={retryingSync}>
            Not now
          </AlertDialogCancel>
          <AlertDialogAction
            type="button"
            variant="outline"
            disabled={retryingSync}
            onClick={onReconnect}
          >
            Reconnect Twitch
          </AlertDialogAction>
          <AlertDialogAction
            type="button"
            disabled={retryingSync}
            onClick={handleRetry}
          >
            {retryingSync ? 'Trying again...' : 'Try again'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default BlockedTermsSyncIssueDialog;
